module.exports = __webpack_public_path__ + "img/about_1.230ca234.jpg";